import { Card } from "./card";

const TableWrapper = ({
  children,
  title = "",
  totalItems = 0,
  currentPage = 1,
  totalPages = 1,
  showPagination = true,
  className = "",
}) => {
  return (
    <Card
      className={`bg-white border border-gray-200 shadow-sm overflow-hidden ${className}`}
    >
      <div className="px-3 sm:px-4 lg:px-6 pt-3 sm:pt-4 pb-2 border-b border-gray-100">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <div className="text-xs sm:text-sm text-gray-600">
            Showing{" "}
            <span className="font-semibold text-gray-700">{totalItems}</span>{" "}
            {title.toLowerCase()}
          </div>
          {showPagination && totalPages > 0 && (
            <div className="text-xs sm:text-sm text-gray-600">
              Page {currentPage} of {totalPages}
            </div>
          )}
        </div>
      </div>

      <div className="overflow-x-auto">{children}</div>
    </Card>
  );
};

export default TableWrapper;
